<template>
    <div class="popup">
        <div class="popup__overlay"></div>
        <div class="popup__content" :class="{video: this.popup === 'Video'}">
            <a href="#" class="popup__close" :class="{info: this.popup === 'Info'}" @click.prevent="closePopup">
                <close></close>
            </a>
            <component :is="popup"></component>
        </div>
    </div>
</template>

<script>
    import close from '@/assets/svg/close.svg';
    import Auth from './Auth';
    import Attention from './Attention';
    import Info from './Info';
    import Video from './Video';
    import Error from './Error';
    import Thank from './Thank';

    export default {
        name: 'BasePopup',
        components: {
            close,
            Auth,
            Attention,
            Info,
            Video,
            Error,
			Thank
        },
        computed: {
            popup() {
                return this.$store.getters['GET_POPUP'];
            },
            popupData() {
                return this.$store.getters['GET_POPUP_DATA'];
            }
        },
        methods: {
            closePopup() {
                if(typeof this.popupData.cb === 'function') {
                    this.popupData.cb();
                }
                this.$store.commit('SET_POPUP', {name: false});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// BasePopup.vue?207c1be2